/**
 * Styles.
 */
import './body.scss';
import './footer.css';
import './header.css';
import './style.scss';

/**
 * External Dependencies
 */
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { showSocketConnectionRetryAlertMessage } from '../../../utils/alert';
import { getRetryUrl } from '../../../utils/socket-io';

/**
 * Internal Dependencies
 */
import AsyncComponent from '../../../components/async-component';

/**
 * Component
 */
const MonitorLive = () => {
  const [loading, setLoading] = useState(true);
  const [autorizzato, setAutorizzato] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const checkMonitorConnesso = useCallback(monitorId => {
    const currentUrl = new URL(window.location);
    const forceSocketConnection = currentUrl.searchParams.get(
      'forceSocketConnection'
    );
    window.api.monitor
      .checkConnesso(monitorId, forceSocketConnection)
      .then(res => {
        const connessioneNonDisponibile = res.data.connesso;
        if (connessioneNonDisponibile) {
          setLoading(true);
          showSocketConnectionRetryAlertMessage('Monitor già in uso', 10).then(
            () => {
              const retryUrl = getRetryUrl(currentUrl);
              window.location.assign(retryUrl);
            }
          );
        } else {
          if (currentUrl.searchParams.has('forceSocketConnection')) {
            currentUrl.searchParams.delete('forceSocketConnection');
            window.location.assign(currentUrl);
          }

          if (window.socket.connected) {
            window.socket.emit('monitor-hello', monitorId);
          }
          window.socket.on('connect', () => {
            window.socket.emit('monitor-hello', monitorId);
          });
          window.socket.on('riavvio', () => {
            window.location.reload();
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (id !== undefined) {
      setAutorizzato(true);
      setLoading(false);
      checkMonitorConnesso(id);
    } else {
      navigate('/');
    }
  }, [id, navigate, checkMonitorConnesso]);

  return (
    <div>
      {!loading ? (
        autorizzato ? (
          <AsyncComponent component={() => import('./content')} />
        ) : (
          <div className="rui-sign align-items-center justify-content-center">
            <p className="display-4 mb-30">Credenziali Monitor Errate</p>
          </div>
        )
      ) : (
        <div className="rui-sign align-items-center justify-content-center">
          <p className="display-4 mb-30">Caricamento...</p>
        </div>
      )}
    </div>
  );
};

export default MonitorLive;
